module.exports = __webpack_public_path__ + "img/cloud-wind-sun-2.e3a88c8c.svg";